import React, { FC } from 'react';
import classNames from 'classnames';
import { Connect, PropsFromRedux } from './DesktopTypeItemContainer';
import styles from './desktop_type_item.module.scss';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';
import { Hyperlink } from '../../../components/Hyperlink';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import { useUser } from '../../../user/useUser';

type Props = PropsFromRedux & {
  onTypeChanged: (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => void;
};

export const RawDesktopTypeItem: FC<Props> = ({
  url,
  selected,
  onTypeChanged,
  children,
}) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();
  const linkProps = accessPremium
    ? {
        href: buildUrlWithParameters(url, {
          source: 'search-types',
        }),
        onClick: onTypeChanged,
      }
    : {
        onClick: () => openRestrictedModal({ source: 'search-types' }),
      };
  return (
    <Hyperlink
      data-test-id="search-type"
      {...linkProps}
      className={classNames(styles.item, selected && styles.selectedItem)}
    >
      {children}
    </Hyperlink>
  );
};

export const DesktopTypeItem = Connect(RawDesktopTypeItem);
